if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }

      if ( this.length > 1 ) {
        this.startAutoPlay(2000, 4000);
      }
      
    }

    changeSlide(direction) {
      if ( this.length === 0 ) return;

      // keep buttons enabled in loop mode
      if ( this.nextButton ) this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      if ( this.prevButton ) this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if ( direction == 'next' ) {
        this.index = (this.index + 1) % this.length;
      } else if ( direction == 'prev' ) {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    startAutoPlay(delayMs = 2000, intervalMs = 2000) {
      this.stopAutoPlay();
      this._autoPlayStart = setTimeout(() => {
        this._autoPlayInterval = setInterval(() => {
          this.changeSlide('next');
        }, intervalMs);
      }, delayMs);
    }

    stopAutoPlay() {
      if ( this._autoPlayStart ) {
        clearTimeout(this._autoPlayStart);
        this._autoPlayStart = null;
      }
      if ( this._autoPlayInterval ) {
        clearInterval(this._autoPlayInterval);
        this._autoPlayInterval = null;
      }
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}